/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum StatusSablonyE {
    Rozpracovana = 'ROZPRACOVANA',
    VracenaKDopracovani = 'VRACENA_K_DOPRACOVANI',
    CekaNaSchvaleni = 'CEKA_NA_SCHVALENI',
    Schvalena = 'SCHVALENA',
    CekaNaPublikaci = 'CEKA_NA_PUBLIKACI',
    Publikovana = 'PUBLIKOVANA',
    Aktivni = 'AKTIVNI',
    Neaktivni = 'NEAKTIVNI',
    Archivovana = 'ARCHIVOVANA',
    Smazana = 'SMAZANA',
    VPriprave = 'V_PRIPRAVE',
    VracenaKPriprave = 'VRACENA_K_PRIPRAVE',
    CekaNaPredschvaleni = 'CEKA_NA_PREDSCHVALENI',
    DokumentaceNahrana = 'DOKUMENTACE_NAHRANA'
}

